// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/**
 * Huit barres en etoile : le bouton qui ne montre que les NOUVEAUTES (rangee
 * 3b, entre « Tri » et l'etoile des favoris). Source `icone-nouveau.svg`.
 *
 * Les traces sont recopies TELS QUELS. Le fichier source est cadre en 2400
 * unites (`translate(0,240) scale(0.1,-0.1)`) : en taille 15, ses barres ne
 * feraient que ~0,8 px, plus fines que l'etoile voisine. Le contour de meme
 * encre sur le groupe (`strokeWidth` 100, soit 10 unites du cadre) les
 * epaissit a l'epaisseur visuelle des autres icones de la barre, sans toucher
 * aux chemins. Le cadre depasse de 5 unites de chaque cote (`-5 -5 250 250`)
 * pour que ce contour ne soit pas rogne aux extremites des barres.
 */
export const IconNouveau = createCustomIcon(
  'IconNouveau',
  '-5 -5 250 250',
  <g
    transform="translate(0,240) scale(0.1,-0.1)"
    fill="currentColor"
    stroke="currentColor"
    strokeWidth={100}
    strokeLinejoin="miter"
  >
    <path d="M1070 2100 l0 -300 130 0 130 0 0 300 0 300 -130 0 -130 0 0 -300z" />
    <path d="M350 2045 l-85 -85 213 -213 212 -212 87 88 88 87 -210 210 c-115 115 -212 210 -215 210 -3 0 -44 -38 -90 -85z" />
    <path d="M1745 1920 l-210 -210 88 -87 87 -88 212 212 213 213 -85 85 c-46 47 -87 85 -90 85 -3 0 -100 -95 -215 -210z" />
    <path d="M0 1200 l0 -130 300 0 300 0 0 130 0 130 -300 0 -300 0 0 -130z" />
    <path d="M1800 1200 l0 -130 300 0 300 0 0 130 0 130 -300 0 -300 0 0 -130z" />
    <path d="M475 650 l-210 -210 88 -87 87 -88 212 212 213 213 -85 85 c-46 47 -87 85 -90 85 -3 0 -100 -95 -215 -210z" />
    <path d="M1620 775 l-85 -85 213 -213 212 -212 87 88 88 87 -210 210 c-115 115 -212 210 -215 210 -3 0 -44 -38 -90 -85z" />
    <path d="M1070 300 l0 -300 130 0 130 0 0 300 0 300 -130 0 -130 0 0 -300z" />
  </g>,
);
